
export enum SubscriptionStatus {
  ACTIVE = 'active',
  INCOMPLETE = 'incomplete',
  CANCELED = 'canceled',
  OUTSTANDING = 'outstanding',
  DELINQUENT = 'delinquent'
}

export enum ReminderFrequency {
    DAILY = 'daily',
    EVERY_OTHER = 'every_other_day',
    AUTO = 'auto'
}

function dateHydrator(input: string | Date): Date {
    return input instanceof Date
        ? input
        :new Date(input);
}

const subscriptionFields = {
    id: { required: true },
    createdAt: { required: true, hydrator: dateHydrator },
    updatedAt: { required: true, hydrator: dateHydrator },
    status: { required: true },
    currentPeriodStart: { required: true, hydrator: dateHydrator },
    currentPeriodEnd: { required: true, hydrator: dateHydrator },
    unpaidReminderFrequency: { required: true },
    organizationId: { required: true },
    cancelAtPeriodEnd: { required: true },
};

export class SubscriptionModel {

    constructor(sub: Partial<SubscriptionModel>) {
        Object.keys(this).forEach(key => {
            if (sub[key] == null && this[key] == null)
                throw new Error(`${key} cannot be null`);

            if (subscriptionFields[key].hydrator != null)
            {
                sub[key] = subscriptionFields[key].hydrator(sub[key]);
            }
        });
        Object.assign(this, sub);
    }


    id: string = null;
    organizationId: string = null;

    createdAt: Date = null;
    updatedAt: Date = null;

    status: SubscriptionStatus = null;

    currentPeriodStart: Date = null;
    currentPeriodEnd: Date = null;

    unpaidReminderFrequency: ReminderFrequency = null;
    cancelAtPeriodEnd: boolean = null;

}
